"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _reactCheckboxTree = _interopRequireDefault(require("react-checkbox-tree"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _TextButton = require("../TextButton");

var _TextField = require("../TextField");

var _Icon = require("../Icon");

var _Protraction = require("../Protraction");

var _styles = require("./styles");

require("react-checkbox-tree/lib/react-checkbox-tree.css");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var addLabelToNode = function addLabelToNode() {
  var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return nodes.map(function (node) {
    return _objectSpread(_objectSpread({}, node), {}, {
      children: (node.children || []).length ? addLabelToNode(node.children) : undefined,
      label: // React checkbox tree does a very expensive comparison when we use a component here
      // This can cause infinite render loops, so render just the label text when possible
      node.label.length > 15 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Protraction.Protraction, {
        variant: "body3",
        children: node.label
      }) : node.label
    });
  });
};

var MultiLevelDropdown = function MultiLevelDropdown(_ref) {
  var _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      _ref$hideExpand = _ref.hideExpand,
      hideExpand = _ref$hideExpand === void 0 ? false : _ref$hideExpand,
      _ref$disableSearch = _ref.disableSearch,
      disableSearch = _ref$disableSearch === void 0 ? false : _ref$disableSearch,
      _ref$disableReset = _ref.disableReset,
      disableReset = _ref$disableReset === void 0 ? false : _ref$disableReset,
      _ref$resetBtnLabel = _ref.resetBtnLabel,
      resetBtnLabel = _ref$resetBtnLabel === void 0 ? "Reset" : _ref$resetBtnLabel,
      _ref$searchPlaceholde = _ref.searchPlaceholder,
      searchPlaceholder = _ref$searchPlaceholde === void 0 ? "Search" : _ref$searchPlaceholde,
      _ref$searchType = _ref.searchType,
      searchType = _ref$searchType === void 0 ? "beginsWith" : _ref$searchType,
      noResultsLabel = _ref.noResultsLabel,
      initialChecked = _ref.initialChecked,
      controlledChecked = _ref.checked,
      _ref$nodes = _ref.nodes,
      nodeFromParent = _ref$nodes === void 0 ? [] : _ref$nodes,
      onCheck = _ref.onCheck;

  var _useState = (0, _react.useState)(controlledChecked || []),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      expanded = _useState4[0],
      setExpanded = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      search = _useState6[0],
      setSearch = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      isDirty = _useState8[0],
      setIsDirty = _useState8[1];

  var onSearchChange = function onSearchChange(_ref2) {
    var value = _ref2.target.value;
    setSearch(value);
  };

  var resetFilter = function resetFilter() {
    setExpanded([]);
    setSearch("");

    if (initialChecked) {
      setChecked(initialChecked);
    } else {
      setChecked([]);
    }
  };

  (0, _react.useEffect)(function () {
    if (onCheck) onCheck(checked);
  }, [checked, onCheck]);
  (0, _react.useEffect)(function () {
    setIsDirty(!(0, _lodash.default)(initialChecked, checked));
  }, [initialChecked, checked]);
  var updateExpanded = (0, _react.useCallback)(function (records) {
    var activeExpanded = [];

    if (records.length === 1) {
      setExpanded([records[0].value]);
      return;
    }

    if (!search) {
      return;
    }

    var recordsWithResults = records.filter(function (rec) {
      return (rec.children || []).length > 0;
    });

    if (recordsWithResults.length) {
      // Check if default search expand provided and it has values when
      // there is nothing expanded
      activeExpanded = recordsWithResults.filter(function (arr) {
        return !!arr.isDefaultSearch;
      }).map(function (_ref3) {
        var value = _ref3.value;
        return value;
      }); // When there isn't anything expanded and default expanded is not
      // available, expand first block which have search results

      if (activeExpanded.length === 0) {
        activeExpanded = [recordsWithResults[0].value];
      }
    }

    setExpanded(function (prevExpanded) {
      if ((prevExpanded || []).length) {
        var record = records.find(function (arr) {
          return arr.value === prevExpanded[0] && (arr.children || []).length;
        });

        if (record) {
          return [record.value];
        }
      }

      return activeExpanded;
    });
  }, [setExpanded, search]);
  var nodes = (0, _react.useMemo)(function () {
    if (!Array.isArray(nodeFromParent) || nodeFromParent.length === 0) {
      return [];
    }

    var operationalArray = addLabelToNode(nodeFromParent.reduce(function (opArray, node) {
      var children = search ? (node.children || []).filter(function (child) {
        return searchType === "beginsWith" ? child.label.toLowerCase().startsWith(search.toLowerCase()) : child.label.toLowerCase().includes(search.toLowerCase());
      }) : node.children;

      if ((children === null || children === void 0 ? void 0 : children.length) === 0) {
        return opArray;
      }

      return [].concat((0, _toConsumableArray2.default)(opArray), [_objectSpread(_objectSpread({}, node), {}, {
        children: children,
        className: "node-list"
      })]);
    }, []));
    updateExpanded(operationalArray);
    return operationalArray;
  }, [nodeFromParent, search, updateExpanded, searchType]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledContainer, {
    fullWidth: fullWidth,
    children: [disableSearch ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledSearchBox, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.TextField, {
        onChange: onSearchChange,
        placeholder: searchPlaceholder,
        value: search
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledCheckboxTree, {
      hideExpand: hideExpand,
      children: nodes.length > 0 || disableSearch || !noResultsLabel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactCheckboxTree.default, {
        checked: controlledChecked || checked,
        expanded: expanded,
        icons: {
          check: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            color: "primary",
            iconName: "check-square",
            size: "large"
          }),
          expandClose: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            color: "primary",
            iconName: "chevron-down",
            size: "small"
          }),
          expandOpen: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            color: "primary",
            iconName: "chevron-up",
            size: "small"
          }),
          halfCheck: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            color: "primary",
            iconName: "minus-square",
            size: "large"
          }),
          uncheck: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            color: "primary",
            iconName: "square",
            iconStyle: "far",
            size: "large"
          })
        },
        nodes: nodes,
        onCheck: setChecked // @ts-ignore - The current version that we are on for `react-checkbox-tree`
        // has incorrect types here for `onExpand.`
        ,
        onExpand: function onExpand(expanded, _ref4) {
          var value = _ref4.value;
          var store = (expanded === null || expanded === void 0 ? void 0 : expanded.length) === 0 ? [] : [value];
          setExpanded(store);
        },
        optimisticToggle: false,
        showNodeIcon: false
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledTypography, {
        variant: "body2",
        children: noResultsLabel
      })
    }), disableReset ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledResetBox, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.TextButton, {
        disabled: initialChecked ? !isDirty : !checked.length,
        label: resetBtnLabel,
        onClick: resetFilter,
        variant: "outlined"
      })
    })]
  });
};

var _default = MultiLevelDropdown;
exports.default = _default;